<template>
  <el-dialog
    class="registe-dialog"
    :visible.sync="visible"
    :title="$t('course.coursequestion.detail')"
    :close-on-click-modal="isClose"
    :close-on-press-escape="isClose"
    :show-close="true"
    @close="visible = false"
    width="1000px"
  >
    <div class="el-dialog__header_cus" slot="title">
      {{ $t("course.coursequestion.detail") }}
    </div>
    <div class="group_5 flex-col"></div>



    <div class="mod-joylearning__assignuser">
      <div class="table-user table">
        <el-table
          :data="dataList"
          border
          height="500px"
          ref="selectReplyList"
          v-loading="dataListLoading"
          style="width: 100%"
          :row-style="pointerStyle"
        >
          <!-- 回复ID -->
          <el-table-column
            prop="courseReplyId"
            :label="$t('course.coursequestion.dialogReplyId')"
            width="100"
            align="left"
            header-align="left"
          >
          </el-table-column>
          <!-- 回复者 -->
          <el-table-column
            prop="userRealName"
            align="left"
            header-align="left"
            show-overflow-tooltip
            :label="$t('course.coursequestion.dialogReplyUser')"
          >
          </el-table-column>
          <!-- 回复时间 -->
          <el-table-column
            prop="replyDate"
            align="left"
            width="180"
            header-align="left"
            show-overflow-tooltip
            :formatter="fmtDate"
            :label="$t('course.coursequestion.dialogReplyDate')"
          >
          <template slot-scope="scope">
              {{ formatDate(scope.row.replyDate) }}
          </template>
          </el-table-column>
          <!-- 回复内容 -->
          <el-table-column
            prop="content"
            :label="$t('course.coursequestion.dialogReplyContent')"
            width="200"
            align="left"
            header-align="left"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- 图片 -->
          <!-- <el-table-column
            prop="img"
            :label="$t('course.coursequestion.img')"
            width="180"
            align="left"
            header-align="left"
          >
            <template slot-scope="scope">
              <div
                v-if="
                  scope.row.replyContentList &&
                  scope.row.replyContentList.length > 0
                "
              >
                <span class="el-dropdown-link" @click="showImage(scope.row)"
                  >查看</span
                >
                <viewer v-show="viewFlag" :images="imageList" ref="viewer">
                  <img
                    v-for="(url, index) in imageList"
                    style="width: 100%"
                    :src="url"
                    :key="index"
                  />
                </viewer>
              </div>
              <div v-else>–</div>
            </template>
          </el-table-column> -->
          <!-- 回复 -->
          <!-- <el-table-column
            prop="reply"
            :label="$t('course.coursequestion.dialogReply')"
            width="150"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <el-link
                v-if="scope.row.replyStatus == '1'"
                type="primary"
                @click="dialogReplyOpen(scope.row)"
                >{{ $t("course.coursequestion.dialogReply") }}</el-link
              >
              <el-button v-if="scope.row.replyStatus != '1'" disabled>{{
                $t("course.coursequestion.dialogReply")
              }}</el-button>
            </template>
          </el-table-column> -->
          <!-- 屏蔽 -->
          <!-- <el-table-column
            prop="shield"
            :label="$t('course.coursequestion.dialogShield')"
            align="center"
          >
            <template slot-scope="scope">
              <el-link
                v-if="scope.row.replyStatus == '1'"
                type="primary"
                @click="doShield(scope.row)"
                >{{ $t("course.coursequestion.dialogShield") }}</el-link
              >
              <el-button v-if="scope.row.replyStatus != '1'" disabled>{{
                $t("course.coursequestion.dialogShielded")
              }}</el-button>
            </template>
          </el-table-column> -->

          <el-table-column
            prop="shield"
            :label="$t('course.coursequestion.dialogShield')"
            align="left"
            header-align="left"
          >
            <template slot-scope="scope">
              <el-link
                v-if="scope.row.replyStatus == '1'&&checkReply()"
                type="primary"
                @click="dialogReplyOpen(scope.row)"
                >{{ $t("course.coursequestion.dialogReply") }}</el-link
              >
              <el-link
                disabled
                type="info"
                v-if="scope.row.replyStatus != '1'||!checkReply()"
                >{{ $t("course.coursequestion.dialogReply") }}</el-link
              >
              <div class="pkg-vertical-divider"></div>
              <el-link
                v-if="scope.row.replyStatus == '1'&&checkShield()"
                type="primary"
                @click="shieldPrompt(scope.row)"
                >{{ $t("course.coursequestion.dialogShield") }}</el-link
              >
              <el-link
                disabled
                type="info"
                v-if="scope.row.replyStatus != '1'&&checkShield()"
                >{{ $t("course.coursequestion.dialogShield") }}</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <reply
      v-if="dialogReplyVisible"
      @getDetailDataList="getDetailDataList"
      :visible.sync="dialogReplyVisible"
      ref="reply"
    ></reply>
    <!--屏蔽-->
    <el-dialog
      :visible.sync="dialogShieldVisible"
      width="431px"
      append-to-body
      :before-close="handleShieldClose"
    >
      <div slot="title">
        <div class="dialog-modl-title-img">
          <img src="@/assets/img/course/Icon／Warning.png" alt="" />
        </div>
        <div class="dialog-modl-title">
          {{ $t("course.coursecomment.shieldConfirmPrompt") }}
        </div>
      </div>

      <div class="dialog-shield-info">
        {{ $t("course.coursecomment.shieldPrompt") }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogShieldVisible = false">{{
          this.$t("course.coursecomment.cancel")
        }}</el-button>
        <el-button type="primary" @click="doShield">{{
          this.$t("course.coursecomment.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import reply from "./reply";
import moment from "moment";

export default {
  components: {
    reply,
  },
  data() {
    return {
      // 显示查看器
      viewFlag: false,
      imageList: [],
      qaId: 0,
      dataListLoading: false,
      visible: false,
      dataList: [],
      rowData: {},
      isClose: true, //控制弹框能否关闭
      getDataListURL: "/course/courseQa/listReplyByQaId",
      shieldURL: "/course/courseQa/updateReplyStatus",
      replyURL: "/course/courseQa/saveCourseReply",
      dialogReplyVisible: false,
      dialogShieldVisible: false,
      courseReplyId: "",
    };
  },
  methods: {
    pointerStyle(){
      return {
    cursor: "pointer",
    fontSize: "14px",
    fontFamily: "PingFang SC-Regular, ingFangSC-Regular, sans-serif",
    fontWeight: 400,
    color: "#252628"
  };
    },
     // 回复按钮权限
     checkReply() {
      if (this.$hasPermission('learning:coursequestion:reply')) {
        return true
      }
      return false
    },
    // 屏蔽按钮权限
    checkShield() {
      if (this.$hasPermission('learning:coursequestion:shield')) {
        return true
      }
      return false
    },
    //查询
    getDetailDataList() {
      this.dataListLoading = true;
      this.isClose = false;
      this.$request
        .post(this.getDataListURL + "?qaId=" + this.qaId)
        .then((res, total, code, data) => {
          this.isClose = true;
          this.dataListLoading = false;
          this.dataList = data;
        })
        .catch(() => {
          this.dataListLoading = false;
          this.isClose = true;
          console.log(" this.$message");
        });
    },
    // doShield(row) {
    //   this.$confirm(
    //     this.$t("course.coursequestion.shieldPrompt"),
    //     this.$t("course.coursequestion.deletePrompt"),
    //     {
    //       confirmButtonText: this.$t("confirm"),
    //       cancelButtonText: this.$t("cancel"),
    //       type: "warning",
    //     }
    //   )
    //     .then(() => {
    //       this.dataListLoading = true;
    //       this.isClose = false;
    //       this.$request
    //         .post(this.shieldURL, {
    //           courseReplyId: row.courseReplyId,
    //           replyStatus: 3,
    //         })
    //         .then((res, total, code, data) => {
    //           console.log(data);
    //           this.isClose = true;
    //           this.dataListLoading = false;
    //           this.$message({
    //             type: "success",
    //             message: this.$t("course.coursequestion.shieldSuccess"),
    //             duration: 5000,
    //           });
    //           this.getDetailDataList();
    //         })
    //         .catch(() => {
    //           this.dataListLoading = false;
    //           this.isClose = true;
    //           console.log(" this.$message");
    //         });
    //     })
    //     .catch(() => {});
    // },
    formatDate(date,format='YYYY-MM-DD HH:mm:ss'){
      return moment(date).format(format)
    },
    fmtDate(row, column, cellValue) {
      cellValue = typeof cellValue == "number" ? cellValue : Number(cellValue);
      var time = new Date(cellValue);
      return `${time.getFullYear()}-${
        time.getMonth() + 1 >= 10
          ? time.getMonth() + 1
          : "0" + (time.getMonth() + 1)
      }-${time.getDate() >= 10 ? time.getDate() : "0" + time.getDate()} ${
        time.getHours() >= 10 ? time.getHours() : "0" + time.getHours()
      }:${
        time.getMinutes() >= 10 ? time.getMinutes() : "0" + time.getMinutes()
      }:${
        time.getSeconds() >= 10 ? time.getSeconds() : "0" + time.getSeconds()
      }`;
    },
    // 查看图片
    showImage(data) {
      this.imageList = [];
      data.replyContentList.forEach((file) => {
        this.imageList.push(file.content);
      });
      this.$refs["viewer"].$viewer.show();
    },
    dialogReplyOpen(row) {
      this.dialogReplyVisible = true;
      this.$nextTick(() => {
        this.$refs.reply.replyId = row.courseReplyId;
        this.$refs.reply.continueFlag = true;
        this.$refs.reply.visible = true;
        this.$refs.reply.getDataList();
      });
    },
    // close() {
    //     this.$emit("update:visible", false);
    //     this.$emit('closeChildDialog')
    // },

    shieldPrompt(row) {
      this.dialogShieldVisible = true;
      this.courseReplyId = row.courseReplyId;
    },
    doShield() {
          this.dataListLoading = true;
          this.isClose = false;
          this.$request
            .post(this.shieldURL, {
              courseReplyId: this.courseReplyId,
              replyStatus: 3,
            })
            .then((res, total, code, data) => {
              console.log(data);
              this.isClose = true;
              this.dataListLoading = false;
              this.dialogShieldVisible = false;
              this.$message({
                type: "success",
                message: this.$t("course.coursequestion.shieldSuccess"),
                duration: 5000,
              });
              this.getDetailDataList();
            })
            .catch(() => {
              this.dataListLoading = false;
              this.isClose = true;
              this.dialogShieldVisible = false;
              console.log(" this.$message");
            });
    },
      handleShieldClose() {
    this.dialogShieldVisible = false;
  },
  },

};
</script>


<style lang="scss" scoped>
@import "../../../../../assets/scss/modules/trainingCharge.scss";
.el-link.el-link--primary {
    color: #1C69D4;
}
.el-dialog__header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px 24px;

  .el-dialog__header_cus {
    height: 22px;
    line-height: 22px;
    color: rgba(37, 38, 40, 100);
    font-size: 17px;
    position: relative;
    padding-left: 11px;
    font-weight: 600;

    &::before {
      content: "";
      width: 3px;
      height: 14px;
      border-radius: 1px;
      display: inline-block;
      background-color: rgba(28, 105, 212, 1);
      position: absolute;
      top: 4px;
      left: 0px;
    }
  }
}




.dialog-modl-title-img {
  width: 80px;
  height: 0px;
  position: relative;
  top: 20px;
  left: 0px;
}

.dialog-modl-title {
  padding-top: 0px !important;
  width: 80px;
  height: 30px;
  position: relative;
  top: 23px;
  left: 30px;
  font-size: 16px;
  font-weight: 600;
  color: #252628;
}
.dialog-info {
  width: 230px;
  line-height: 25px;
  padding-left: 30px !important;
  align-content: left;
  word-break: break-all !important;
  color: rgb(8, 8, 8);
  font-size: 14px;
  font-weight: 400;
}

.dialog-shield-info {
  width: 260px;
  line-height: 25px;
  padding-left: 30px !important;
  align-content: left;
  word-break: break-all !important;
  color: rgb(8, 8, 8);
  font-size: 14px;
  font-weight: 400;
}

.dialog-footer {
  margin: 10px;
  padding-bottom: 20px !important;
  padding-top: 0px !important;
  align-content: right;
  // width: 800px;
}
.el-dialog__close{
            width: 14px;
            height: 14px;
            background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng2bd9d0937e19fe2b8ac42089f015deb04da688a4b0ea468769876c737dc32bdb)
              100% no-repeat;
            background-size: 100% 100%;
            margin: 4px 0 0 595px;
          }
.group_5 {
     background-color: rgba(0, 0, 0, 0.1);
    width: 961px;
    height: 1px;
    margin-top: -16px;
    margin-bottom: 17px;
}

</style>
